<template>
  <div class="mt-10 grid gap-6 sm:grid-cols-3 gap-y-10">
    <div v-for="(item, index) in visibleNews" :key="index" class="news-card">
      <a :href="item.link" class="group" target="_self">
        <article class="flex flex-col gap-y-6">
          <div class="relative">
            <figure class="relative max-w-96">
              <img
                :src="item.image.url"
                :alt="item.image.alt"
                class="news-image w-full h-full object-cover"
              />
              <div
                class="bg-black opacity-30 absolute inset-0 hidden rounded group-hover:block"
              ></div>
            </figure>
            <p class="tag-secondary tag-small absolute top-4 left-4">
              {{ item.label }}
            </p>
            <p class="underline group-hover:text-light-grey heading-sm mt-6">
              {{ item.title }}
            </p>
          </div>
        </article>
      </a>
    </div>
  </div>
  <div class="flex justify-center mt-10">
    <button
      :disabled="visibleNews.length >= props.news.length"
      class="btn-load-more"
      @click="loadMore"
    >
      {{
        visibleNews.length >= props.news.length
          ? props.button_text_disable
          : props.button_text_enable
      }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

interface NewsItem {
  label: string
  image: {
    url: string
    alt?: string
  }
  title: string
  link: string
}

const props = defineProps<{
  news: NewsItem[]
  button_text_disable: string
  button_text_enable: string
}>()

const visibleCount = ref(6)

const visibleNews = computed(() => {
  return props.news.slice(0, visibleCount.value)
})

const loadMore = () => {
  visibleCount.value += 6
}
</script>

<style scoped>
.news-image {
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 8px;
}

.btn-load-more {
  background-color: #111;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-family: 'Apfel Grotezk';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
  transition: opacity 0.3s ease;
  width: 100%;
  height: 52px;
}

.btn-load-more:hover {
  background-color: #333;
}

.btn-load-more:disabled {
  opacity: 0.8;
  cursor: not-allowed;
}
</style>
